<template>
  <div v-if="list.length" scroll-y="true" class="im-quick-reply-list">
    <div
      v-for="(item, index) in quickReplyList"
      :key="index"
      class="im-quick-reply-item"
      @click="onSelect(item)"
    >
      <div v-if="status" class="icons-wrap">
        <!-- <div v-if="item.disabled" class="unknow">禁用</div> -->
        <div v-if="item.isActive" class="active">
          <uni-icons type="checkbox-filled" color="#0089ff" size="16" />
        </div>
        <div v-else class="unactive">
          <uni-icons color="#cecece" type="circle" size="16" />
        </div>
      </div>
      <div class="text">{{ item.message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickReplyList',
  props: {
    status: {
      // 编辑状态
      type: Boolean,
      default: false
    },
    list: {
      // 列表
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      quickReplyList: []
    }
  },
  watch: {
    list(n) {
      // 直接使用props不能被vue追踪
      this.quickReplyList = n
    }
  },
  created() {
    this.quickReplyList = this.list
  },
  methods: {
    onSelect(data) {
      if (this.status) {
        data.isActive = !data.isActive
        this.$emit('checked', data)
        return
      }
      this.$emit('selected', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-quick-reply-list {
  padding-left: 0.725333rem;
  padding-right: 0.682667rem;
  flex: 1;
  width: auto;
  overflow: hidden;
  height: 100%;

  .im-quick-reply-item {
    display: flex;
    align-items: center;
    padding: 0.682667rem 0;
    border-top: 0.021333rem solid #ececec;
    overflow: hidden;

    .icons-wrap {
      flex: 0 0 0.682667rem;
      width: 0.682667rem;
      overflow: hidden;
      .active,
      .unactive,
      .unknow {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0.682667rem;
        height: 0.682667rem;
      }

      .unactive {
        color: #cecece;
      }

      .active {
        color: #0089ff;
      }
    }

    .text {
      flex: 1;
      padding: 0 0.256rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
      word-break: break-all;
      font-size: 0.64rem;
      line-height: 0.682667rem;

      font-weight: 400;
      color: #222222;
    }
  }
}
</style>
